var _this = this;
export var debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = _this;
        var args = { func: func, wait: wait, immediate: immediate };
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};
export var formatNumber = function (num) {
    // TODO: Evaluate our usage of this function and update to use Number.isNaN
    // (which returns false for {}'s and []'s which is a problem)
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num) || num === null) {
        return '';
    }
    var n = num.toString();
    if (n.length < 4) {
        return n;
    }
    return n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var mergeRefs = function () {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return function (element) {
        refs.forEach(function (ref) {
            if (!ref) {
                return;
            }
            if (typeof ref === 'function') {
                ref(element);
            }
            else {
                // eslint-disable-next-line no-param-reassign
                ref.current = element;
            }
        });
    };
};
